import React, { useState, useEffect } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";

let debounceTimer;
function Menu() {
  let logoFawesome = "./assets/images/logo.svg";
  let searchIcon = "./assets/images/search.svg";
  const [inputValue, setInputValue] = useState("");
  const [isWide, setIsWide] = useState(window.innerWidth >= 1400);

  useEffect(() => {
    const handleResize = () => {
      setIsWide(window.innerWidth >= 1400);
    };
    window.addEventListener("resize", handleResize);

    const navLinks = document.querySelectorAll(".bg-body-tertiary .nav-link");
    const searchInput = document.querySelectorAll(
      ".bg-body-tertiary #search-input"
    );
    navLinks.forEach((link) => {
      link.classList.add("gtm-lp", "gtm-nav-link");
    });
    searchInput.forEach((link) => {
      link.classList.add("gtm-lp", "gtm-search-text");
    });

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuInfo = [
    { name: "Home", link: `${document.location.origin}/` },
    { name: "Shows", link: `${document.location.origin}/categories/shows` },
    {
      name: "Movies",
      link: `${document.location.origin}/categories/movies`,
    },    
    {
      name: "Collections",
      link: `${document.location.origin}/categories/collections`,
    },
    {
      name: "Partnerships",
      link: `${document.location.origin}/partnerships`,
    },
    /*{
      name: "Handpicked",
      link: `${document.location.origin}/categories/handpicked`,
    },*/    
    {
      name: "Handpicked",
      link: `${document.location.origin}/categories/handpicked`,
    },
    {
      name: "En Español",
      link: `${document.location.origin}/categories/en-español`,
    },
    /*{
      name: "Top YouTubers",
      link: `${document.location.origin}/categories/top-youtubers`,
    },*/
    {
      name: "Games",
      link: `${document.location.origin}/games`,
    },
    { name: "Search", link: `${document.location.origin}/` },
    {
      name: "About",
      link: `${document.location.origin}/about`,
    },
  ];

  return (
    <Navbar className="bg-body-tertiary navbar-dark pb-2" expand="xxl">
      <div className="container-fluid  px-xxl-5">
        <Navbar.Brand href="/">
          <img
            src={logoFawesome}
            className="img-fluid fw-logo"
            alt="Fawesome"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          {getNamedMenu()}
        </Navbar.Collapse>
      </div>
    </Navbar>
  );

  function getNamedMenu() {
    const currentPath = window.location.pathname;

    // Separate special menus
    const searchMenu = menuInfo.find((item) => item.name === "Search");
    const aboutMenu = menuInfo.find((item) => item.name === "About");

    // Filter out Search and About for main handling
    const mainMenus = menuInfo.filter(
      (item) => item.name !== "Search" && item.name !== "About"
    );

    // If wide screen and more than 6 menus, split into visible + More
    const limit = 5;
    let visibleMenus = mainMenus;
    let moreMenus = [];
    if (isWide && mainMenus.length > limit) {
      visibleMenus = mainMenus.slice(0, limit);
      moreMenus = mainMenus.slice(limit);
    }

    return (
      <>
        {/* Search comes first if <=1399px */}
        {!isWide && searchMenu && renderSearchInput()}

        {visibleMenus.map((item, index) => (
          <Nav.Link
            href={item.link}
            key={index}
            className={
              currentPath === new URL(item.link).pathname ? "active" : ""
            }
          >
            {item.name}
          </Nav.Link>
        ))}

        {isWide && moreMenus.length > 0 && (
          <NavDropdown title="More" id="more-nav-dropdown">
            {moreMenus.map((item, index) => (
              <NavDropdown.Item href={item.link} key={index}>
                {item.name}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        )}

        {/* Search comes after menus if >=1400px */}
        {isWide && searchMenu && renderSearchInput()}

        {/* About always at the end */}
        {aboutMenu && (
          <Nav.Link
            href={aboutMenu.link}
            key="about"
            className={
              currentPath === new URL(aboutMenu.link).pathname ? "active" : ""
            }
          >
            {aboutMenu.name}
          </Nav.Link>
        )}
      </>
    );
  }

  function getNamedMenuOld() {
    // Separate special menus
    const searchMenu = menuInfo.find((item) => item.name === "Search");
    const aboutMenu = menuInfo.find((item) => item.name === "About");

    // Filter out Search and About for main handling
    const mainMenus = menuInfo.filter(
      (item) => item.name !== "Search" && item.name !== "About"
    );

    // If wide screen and more than 6 menus, split into visible + More
    const limit = 5;
    let visibleMenus = mainMenus;
    let moreMenus = [];
    if (isWide && mainMenus.length > limit) {
      visibleMenus = mainMenus.slice(0, limit);
      moreMenus = mainMenus.slice(limit);
    }

    return (
      <>
        {visibleMenus.map((item, index) => (
          <Nav.Link href={item.link} key={index}>
            {item.name}
          </Nav.Link>
        ))}

        {isWide && moreMenus.length > 0 && (
          <NavDropdown title="More" id="more-nav-dropdown">
            {moreMenus.map((item, index) => (
              <NavDropdown.Item href={item.link} key={index}>
                {item.name}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        )}

        {/* Keep Search in its custom style */}
        {searchMenu && (
          <div
            className="cursor-auto nav-link gtm-lp gtm-nav-link"
            key="search"
          >
            <div className="row">
              <div className="input-group">
                <img
                  src={searchIcon}
                  className="img-fluid fw-logo"
                  alt="Fawesome"
                />
                <input
                  className="form-control"
                  id="search-input"
                  placeholder="Search"
                  value={inputValue}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        )}

        {/* About always at the end */}
        {aboutMenu && (
          <Nav.Link href={aboutMenu.link} key="about">
            {aboutMenu.name}
          </Nav.Link>
        )}
      </>
    );
  }

  function renderSearchInput() {
    return (
      <div className="cursor-auto nav-link gtm-lp gtm-nav-link" key="search">
        <div className="row">
          <div className="input-group">
            <img
              src={searchIcon}
              className="img-fluid fw-logo"
              alt="Fawesome"
            />
            <input
              className="form-control"
              id="search-input"
              placeholder="Search"
              value={inputValue}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              autoComplete="off"
            />
          </div>
        </div>
      </div>
    );
  }

  function isValidInputForSearch(str) {
    return /^[a-zA-Z0-9](?!.*[%\/\\?]).*$/.test(str);
  }

  function handleChange(event) {
    var currentValue = event.target.value;
    if (!isValidInputForSearch(currentValue)) {
      event.target.value = currentValue.slice(0, -1);
    }
    var searchText = event.target.value;
    setInputValue(searchText);

    var debounceDelay = 2000;
    if (searchText.length >= 2) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        window.location.href = `${document.location.origin}/search/${searchText}`;
      }, debounceDelay);
    }
  }

  function handleKeyDown(event) {
    var searchText = event.target.value;
    clearTimeout(debounceTimer);
    if (event.key === "Enter") {
      if (searchText.length >= 2) {
        window.location.href = `${document.location.origin}/search/${searchText}`;
      }
    }
  }
}
export default Menu;
